import { IIncident } from 'core/interfaces/IIncidents';
import { v3 } from './base';

export function getIncidentById(incidentId: string) {
  return v3.get<IIncident>(`/incidents/${incidentId}`).then(r => r.data);
}
